import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealsBoardApi, dealsBoardQueryKeys } from '@crm/entities/deals-board';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

export const useEditColumnMutation = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: dealsBoardApi.editColumnData,
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: dealsBoardQueryKeys.board() });
        },
        onSuccess: () => {
            toastManager.onSuccess({
                title: t('crm.deals.board.column.editSuccess'),
            });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(error, t('crm.deals.board.column.editError')),
            });
        },
    });
};
